export default __webpack_public_path__ + "static/media/6be0e667109d01fb819fbf937b407a051576756618189.c2d712d6.webp";